import { silentLogger } from '../protocol/types.js';
import { TypedEmitter } from '../util/emitter.js';
export class KeyBridge {
    constructor(logger = silentLogger) {
        this.emitter = new TypedEmitter();
        this.latest = new Map();
        this.applied = new Set();
        this.pending = [];
        this.logger = logger;
    }
    attachSignalling(signalling) {
        this.detachSignalling?.();
        this.detachSignalling = signalling.on('mediaKey', key => {
            void this.accept(key);
        });
    }
    async attachSink(sink) {
        this.sink = sink;
        const queued = this.pending.splice(0, this.pending.length);
        for (const key of queued) {
            await this.apply(key);
        }
    }
    hasKeyFor(identity) {
        return this.applied.has(identity);
    }
    keyedIdentities() {
        return new Set(this.applied);
    }
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    dispose() {
        this.detachSignalling?.();
        this.detachSignalling = undefined;
        this.sink = undefined;
        this.pending.length = 0;
        this.latest.clear();
        this.applied.clear();
        this.emitter.removeAll();
    }
    async accept(key) {
        this.latest.set(key.livekitIdentity, key);
        if (!this.sink) {
            this.pending.push(key);
            return;
        }
        await this.apply(key);
    }
    async apply(key) {
        const sink = this.sink;
        if (!sink) {
            this.pending.push(key);
            return;
        }
        try {
            await sink.setKey(key.livekitIdentity, key.key, key.index);
            this.applied.add(key.livekitIdentity);
            this.logger.debug('rtc.keys.applied', { identity: key.livekitIdentity, index: key.index });
            this.emitter.emit('keysChanged', this.keyedIdentities());
        }
        catch (error) {
            this.logger.error('rtc.keys.apply_failed', { identity: key.livekitIdentity, error: String(error) });
            this.emitter.emit('keyError', key.livekitIdentity, error);
        }
    }
}
